import * as React from 'react';

const eye = (props: any) => {
  const { colorPrimary } = props;

  return (
    <>
      <g fill="none" fillRule="evenodd">
        <path
          d="M4.16667 50C4.16667 50 20.8333 16.6667 50 16.6667C79.1667 16.6667 95.8333 50 95.8333 50C95.8333 50 79.1667 83.3333 50 83.3333C20.8333 83.3333 4.16667 50 4.16667 50Z"
          stroke="#2A2B2E"
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50 62.5C56.9037 62.5 62.5 56.9037 62.5 50C62.5 43.0962 56.9037 37.5 50 37.5C43.0962 37.5 37.5 43.0962 37.5 50C37.5 56.9037 43.0962 62.5 50 62.5Z"
          stroke={colorPrimary}
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </>
  );
};
export default eye;
